import React from 'react';
import classnames from 'classnames';
import { ShowIf } from '../../flayr-components/ShowIf/ShowIf';
import { Checkbox } from '../../flayr-components/Checkbox/Checkbox';
import { Radio } from '../../flayr-components/Radio/Radio';
import RadioCheckbox from '../../flayr-components/RadioCheckbox/RadioCheckbox';

interface IBoxSelectProps {
  name?: string;
  value?: any;
  checked?: boolean;
  className?: string;
  title?: React.ReactNode;
  titleClassName?: string;
  subTitle?: React.ReactNode;
  subTitleClassName?: string;
  inActiveClassName?: string;
  activeClassName?: string;
  checkboxClassName?: string;
  checkboxType?: 'checkbox' | 'radio' | 'radioCheckbox';
  id?: string;
  onChange?: (e?: any) => void;
}

const BoxSelect: React.FC<React.PropsWithChildren<IBoxSelectProps>> = ({
  className,
  value,
  name,
  checked,
  title,
  titleClassName,
  subTitle,
  subTitleClassName,
  inActiveClassName = 'border-gray-400',
  activeClassName = 'border-primary',
  checkboxType = 'checkbox',
  children,
  onChange,
  checkboxClassName,
  id,
}) => {
  const CheckboxComponent =
    (checkboxType === 'checkbox' && Checkbox) ||
    (checkboxType === 'radio' && Radio) ||
    RadioCheckbox;
  return (
    <label
      className={classnames(
        className,
        'flex rounded-xl border md:cursor-pointer p-3',
        {
          [inActiveClassName]: !checked,
          [activeClassName]: checked,
        }
      )}
      htmlFor={id}
    >
      <div className="flex-grow">
        <ShowIf condition={title}>
          <div className="text-lg font-medium text-gray-700">
            <div className={titleClassName}>{title}</div>
          </div>
        </ShowIf>
        <ShowIf condition={subTitle}>
          <div className="leading-snug text-gray-500">
            <div className={subTitleClassName}>{subTitle}</div>
          </div>
        </ShowIf>
        {children}
      </div>
      <div className="pt-1 pl-3">
        <CheckboxComponent
          className={checkboxClassName}
          name={name}
          checked={checked}
          onChange={onChange}
          readOnly={!onChange}
          value={value}
          id={id}
        />
      </div>
    </label>
  );
};
export default BoxSelect;
